import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import { paymentFormActions } from '@common-reducers/PaymentFormReducer';
import { Alert, Snackbar } from '@mui/material';

/**
 * Shows why the hosted-checkout redirect failed.
 *
 * This exists because the failure used to be completely invisible: `openCheckoutPageThunk` logged
 * to the console and reset the loading flag, so the "Upgrade" button spun, stopped, and left the
 * customer on an unchanged page with no explanation. A customer whose stored email contained a
 * stray space could never reach Chargebee and had no way to find that out.
 *
 * Mount once per page that can start a checkout — it renders nothing until something fails.
 */
export function CheckoutErrorAlert() {
    const dispatch = useAppDispatch();
    const checkoutErrorMessage = useAppSelector((state) => state.PaymentFormReducer.checkoutErrorMessage);

    const handleClose = () => {
        dispatch(paymentFormActions.clearCheckoutErrorMessage());
    };

    return (
        <Snackbar
            open={Boolean(checkoutErrorMessage)}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            // No autoHideDuration: the message is usually actionable ("fix your email address"),
            // so it stays until dismissed rather than vanishing before it can be read.
        >
            <Alert onClose={handleClose} severity="error" variant="filled" sx={{ maxWidth: 480 }}>
                {checkoutErrorMessage}
            </Alert>
        </Snackbar>
    );
}

export default CheckoutErrorAlert;
